import { LevelIndicatorBars } from "@/components/ui/LevelIndicatorBars";
import {
  LEVEL_BAR_GRAY,
  LEVEL_INDICATOR_ACTIVE,
  SEARCH_BADGE_COURSE_BG,
} from "@/components/search/globalSearchConstants";
import type { Course } from "@/types";
import React from "react";
import { View } from "react-native";

type CatalogSkillLevelPillProps = {
  level: NonNullable<Course["skill_level"]>;
};

export function CatalogSkillLevelPill({ level }: CatalogSkillLevelPillProps) {
  return (
    <View
      style={{
        backgroundColor: SEARCH_BADGE_COURSE_BG,
        paddingHorizontal: 4,
        height: 16,
        borderRadius: 4,
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      <LevelIndicatorBars
        level={level}
        activeColor={LEVEL_INDICATOR_ACTIVE}
        inactiveColor={LEVEL_BAR_GRAY}
        size={12}
      />
    </View>
  );
}
